module.exports = __webpack_public_path__ + "img/icon_complain.a8b72c5e.png";